export default __webpack_public_path__ + "static/media/iconSeo.4bc99a89.svg";